/**
 * 🔒 Job Progress on the Work Order page (piece 29; decision 6020; T2787): the
 * band's heading, its two lists and each milestone's dated and not-yet forms.
 * Spread into the one lookup in `strings.ts`. 🔨 This file imports nothing.
 */
export const WORK_ORDER_PROGRESS_STRINGS = {
  'workOrder.progress.panel': 'Job Progress',
  'workOrder.progress.steps': 'Where the Job Stands',
  'workOrder.progress.milestones': 'Milestones',
  'workOrder.progress.void': 'Void',
  'workOrder.progress.kind.visit': 'Visit',
  'workOrder.progress.kind.serviceReport': 'Service Report',
  'workOrder.progress.kind.invoice': 'Invoice',
  'workOrder.progress.completed': 'Completed {date}',
  'workOrder.progress.booked': 'Booked for {date}',
  'workOrder.progress.signed': 'Signed {date}',
  'workOrder.progress.signedUndated': 'Signed',
  'workOrder.progress.raised': 'Raised {date}',
  'workOrder.progress.notYet': 'Not yet',
  'workOrder.progress.notBooked': 'Not booked yet',
} as const;
